import { v4 as uuid } from 'uuid';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export interface IVumRoleStatusResponse {
    readonly status: string;
}

export class VumUserRoleClient {

    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(private readonly authService: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-vum-${stage}`
    }

    public async getUserRoleStatus(vin: string, isWcar: boolean): Promise<IVumRoleStatusResponse | undefined> {
        let response: Response;
        try {
            response = await this.authService.get(this.resourceHostId, `users/me/${vin}/rolestatus?gdc=${this.getGdcType(isWcar)}`, { traceId: uuid() });
        } catch (e) {
            return undefined;
        }

        if (!response.ok) {
            return undefined;
        }

        return await response.json() as IVumRoleStatusResponse;
    }
}